/* Refresh marquee: seamless, constant-speed scrolling text.
   Replaces the theme's text-shadow marquee (whose copies were spaced by a `ch` estimate,
   so the loop point showed a gap and a jump). Builds a track of repeated copies and moves
   it by exactly one copy's width per cycle, at a fixed speed in pixels per second. */
(function () {
  function build(inner) {
    var p = inner.querySelector('.marquee-styles__text');
    if (!p || inner.dataset.rfMarquee) return;
    inner.dataset.rfMarquee = '1';

    var html = p.innerHTML.trim();
    if (!/[✦✧•·]\s*$/.test(p.textContent.trim())) html += '  ✦  ';

    var track = document.createElement('div');
    track.className = 'rf-marquee__track';
    p.className += ' rf-marquee__text';
    p.innerHTML = '';
    p.appendChild(track);

    function render() {
      track.innerHTML = '';
      var probe = document.createElement('span');
      probe.className = 'rf-marquee__item';
      probe.innerHTML = html;
      track.appendChild(probe);
      var w = probe.getBoundingClientRect().width;
      if (!w) return;
      var copies = Math.max(3, Math.ceil((window.innerWidth * 2) / w) + 1);
      for (var i = 1; i < copies; i++) track.appendChild(probe.cloneNode(true));
      var pxps = parseFloat(getComputedStyle(inner).getPropertyValue('--rf-marquee-pxps')) || 105;
      track.style.setProperty('--rf-mq-shift', '-' + w + 'px');
      track.style.setProperty('--rf-mq-duration', (w / pxps) + 's');
    }

    render();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(render, 200); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
  }

  function init() { document.querySelectorAll('.marquee-styles__inner').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
